'use client'

import { BodyLong, Button, Modal } from '@navikt/ds-react'
import React, { ReactElement } from 'react'

import { useMode } from '#core/providers/Modes'
import { useAppSelector } from '#core/redux/hooks'

export function LoggedOutWarning(): ReactElement | null {
    const isSessionExpired = useAppSelector((state) => state.metadata.sessionExpired)
    const mode = useMode()

    if (!isSessionExpired) {
        return null
    }

    return (
        <Modal
            open
            onClose={() => void 0}
            header={{
                heading: 'Du har blitt logget ut',
                closeButton: false,
            }}
            width="small"
        >
            <Modal.Body>
                <BodyLong spacing>
                    {mode.type === 'FHIR'
                        ? 'Du har blitt logget ut av sykmeldingsløsningen for denne pasienten.'
                        : 'Du har blitt logget ut av sykmeldingsløsningen.'}
                </BodyLong>
                <BodyLong>
                    {mode.type === 'FHIR'
                        ? 'Du kan prøve å laste siden på nytt, dersom dette ikke fungerer, må du må gjenåpne applikasjonen fra ditt journalsystem.'
                        : 'Du kan laste siden på nytt for å logge inn igjen.'}
                </BodyLong>
            </Modal.Body>
            <Modal.Footer>
                <Button data-color="neutral" type="button" variant="secondary" onClick={() => window.location.reload()}>
                    {mode.type === 'FHIR' ? 'Last siden på nytt' : 'Logg inn igjen'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
